const Backbone = require('backbone');
const PricedOptionModel = require('app/models/store/client/product/pricedoption');
const KeyCodeView = require('views/store/pages/products/key_code');

let imgId;
const PricedOptionView = Backbone.View.extend({
	model: PricedOptionModel,
	events: {
		change: '_selectionChange',
		mouseenter: '_selectionHoverIn',
		mouseleave: '_selectionHoverOut'
	},
	initialize: function() {
		const $elem = $(`#js-pricedoption-${this.model.get('id')}, #js-pricedoption-${this.model.get('identity')}`);
		this.setElement($elem);
		this.$previewBox = this.$el.closest('.js-product-config-item').find('.js-preview-box');

		if (window.dataLayer.keyCodeValidationEnabled && this.model.get('isKeyCode')) {
			this.keyCode = new KeyCodeView({
				el: window.BCOM.device.isMobile ? this.$el : this.$('input')
			});
		}

		this.listenTo(Backbone, 'priceOption:validationError', this._onPriceOptionError);
	},
	_otherRadioOptions(currentModelId) {
		// returns a filter function that knows about the cid of the currently selected option
		return function(model) {
			const isCurrentModel = currentModelId === model.cid;
			const isRadio = model.get('inputType') === 'radio';
			return isRadio && !isCurrentModel;
		};
	},
	/**
	 * _selectionChange Callback handler for click events on priced options
	 */
	_selectionChange: function() {
		const $input = this.$el.find('input'),
			$option = $input.length >= 1 ? $input : this.$el;

		if ($option.prop('type') === 'checkbox' || $option.prop('type') === 'radio') {
			const isSelected = $option.is(':checked'),
				name = this.$el.data('name');
			this.model.set('selected', isSelected);
			$(`#js-required-${name}`).hide();
			this.$el.closest('li').addClass('selected');
			imgId = this.$el.data('id');
			if (window.BCOM.device.isDesktop) {
				this._setPreviewImage(imgId);
			}
			/**
			 * After we've marked this option as selected, if we have a radio group, we need to unset all the other options
			 */
			if ($option.prop('type') === 'radio') {
				const cid = this.model.cid,
					otherOptions = this.model.collection.models.filter(this._otherRadioOptions(cid));

				otherOptions.forEach((model) => {
					/**
					 * Only unset if it's been set
					 */
					if (model.get('selected')) {
						model.set('selected', false);
						$(`#js-pricedoption-${model.id}`)
							.closest('li')
							.removeClass('selected');
					}
				});
			} else {
				this.$el.closest('li').toggleClass('selected', isSelected);
			}
		} else if ($option.prop('type') === 'select-one') {
			this.model.set({
				selected: this.model.get('name') === $option.val()
			});
		} else {
			this.model.set({
				selected: $option.val().length > 0,
				keyCode: $option.val()
			});
			this.$el.find('.js-pricedoption-validation').hide();
		}
	},
	_selectionHoverIn: function() {
		const hoveringImgId = this.$el.data('id');
		if (this.model.get('selected')) {
			return;
		}
		if (window.BCOM.device.isDesktop && hoveringImgId) {
			this._setPreviewImage(hoveringImgId);
		}
	},
	_selectionHoverOut: function() {
		const currentImgId = this.$el
			.closest('li')
			.siblings('.selected')
			.first()
			.find('label')
			.data('id');
		if (this.model.get('selected')) {
			return;
		}
		if (window.BCOM.device.isDesktop) {
			if (currentImgId) {
				this._setPreviewImage(currentImgId);
			} else {
				this.$previewBox.addClass('unselected').html('');
			}
		}
	},
	_setPreviewImage: function(imgId) {
		const $img = $(`.js-priced-option-picture-${imgId}`)
			.clone()
			.removeClass(`hidden js-priced-option-picture-${imgId}`);
		this.$previewBox.removeClass('unselected').html($img);
	},
	_onPriceOptionError: function(errInfo) {
		if (this.model.get('id') === errInfo.prodOptionItem) {
			this.$el
				.find('.js-pricedoption-validation')
				.show()
				.html(errInfo.prodOptionError);
		}
	}
});

module.exports = PricedOptionView;
